import { g as n } from "./_commonjsHelpers-OnjxAlhP.js";
import { useEffect as s, useRef as a } from "react";
const u = (e) => {
  s(() => {
    var t;
    return (t = n().window) == null || t.addEventListener("keydown", e, !1), () => {
      var o;
      (o = n().window) == null || o.removeEventListener("keydown", e, !1);
    };
  }, [e]);
}, r = (e) => {
  var t;
  return (t = n().document) == null ? void 0 : t.getElementById(e);
}, l = (e) => {
  const t = a(r(e));
  return s(() => {
    t.current = r(e);
  }, [e]), t.current;
};
export {
  u as a,
  l as u
};
